








































































































import { IconSize, SearchBoxSize } from '@getaccept/lib-ui';
import type { SelectEntity } from '@getaccept/lib-shared/src/select-entity/types/select-entity';
import { UserRoleLegacy } from '@getaccept/lib-shared/src/users/types/user-role-legacy';
import { logOut } from '@getaccept/lib-shared/src/helpers/log-out.helper';
import { PathName } from '@getaccept/lib-shared/src/enums/PathNames';
import { defineComponent, ref, computed, onMounted, watch } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import { Feature, useFeatureStore } from '@getaccept/feature-restriction';
import { useSessionStore } from '../../session/store/session.store';
import { useEntityStore } from '../../entity/entity.store';
import { useUserStore } from '../../user/store/user.store';
import { useModulesStore } from '../../modules/store/modules.store';
import { useSubscriptionStore } from '../../subscription/store/subscription.store';
import { useMyDocumentsAuth } from '../../my-documents/composables/my-documents-auth.composable';
import ProfileDropdownButton from './ProfileDropdownButton.vue';

export default defineComponent({
  components: {
    ProfileDropdownButton,
  },
  setup(_, { emit }) {
    const { features } = storeToRefs(useFeatureStore());
    const { isInactiveSubscription } = storeToRefs(useSubscriptionStore());
    const { isContractRoomModuleActive } = storeToRefs(useModulesStore());
    const { entities, entity } = storeToRefs(useEntityStore());
    const searchInput = ref('');
    const { session } = useSessionStore();
    const { user } = storeToRefs(useUserStore());

    const entityName = computed(() => entity.value?.name);
    const userRole = computed(() => session?.user_role);
    const isSubEntity = computed(() => session?.is_sub_entity);

    const filteredEntities = computed(() =>
      searchInput.value
        ? entities.value.filter((entity: SelectEntity) =>
            [entity.name].some((queryableProperty: string) =>
              queryableProperty.toLowerCase().includes(searchInput.value.toLowerCase())
            )
          )
        : entities.value
    );

    const showSubscriptionLink = computed(
      () =>
        userRole.value === UserRoleLegacy.Admin &&
        !isSubEntity.value &&
        !isInactiveSubscription.value
    );

    const handleSelectEntity = (entity: SelectEntity) => emit('selectEntity', entity);

    const handleClick = (event: Event) => emit('click', event);

    const handleLogout = () => logOut();

    const enableFetchMyDocumentsToken = ref(false);

    const { isInvalidToken, token, redirect } = useMyDocumentsAuth(
      computed(() => user.value?.id),
      computed(() => enableFetchMyDocumentsToken.value)
    );

    const handleClickMyDocuments = () => {
      if (!enableFetchMyDocumentsToken.value) {
        enableFetchMyDocumentsToken.value = true;
        return;
      }
      if (token.value) {
        redirect();
        return;
      }
      emit('validate-md-email');
    };

    watch(isInvalidToken, () => {
      if (isInvalidToken.value) {
        emit('validate-md-email');
      }
    });

    const showMyDocumentsOption = computed(
      () =>
        !isInactiveSubscription.value &&
        isContractRoomModuleActive.value &&
        !features.value[Feature.MyDocuments].restricted
    );

    onMounted(() => useEntityStore().loadEntities());

    return {
      location,
      PathName,
      UserRoleLegacy,
      IconSize,
      SearchBoxSize,
      searchInput,
      user,
      userRole,
      entityName,
      isSubEntity,
      entities,
      filteredEntities,
      showMyDocumentsOption,
      handleClickMyDocuments,
      handleSelectEntity,
      handleClick,
      handleLogout,
      isInactiveSubscription,
      showSubscriptionLink,
    };
  },
});
